import { render, staticRenderFns } from "./UploadModal.vue?vue&type=template&id=cf352796&scoped=true&"
import script from "./UploadModal.vue?vue&type=script&lang=ts&"
export * from "./UploadModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf352796",
  null
  
)

export default component.exports